import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-multi-file",
  "use": "icon-multi-file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-multi-file\"><defs><style></style></defs><path d=\"M771.29 231.043L589.375 64.223h-461.35v776.689H771.29V231.043zM190.863 781.22V123.915h344.91v162.929h172.678V781.22H190.863z\" /><path d=\"M833.336 287.209v612.657H253.275v59.692h642.899V287.209zm-577.103 84.324h386.849v58.2H256.233z\" /><path d=\"M256.233 510.344h386.849v58.2H256.233zm0 138.811h386.849v58.2H256.233z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol